/* global Sys, Services */
Sys.ns("Services");

/**
 * The Activity Service handles the indication of slow progress in the game (e.g. slow server request).
 *
 * @class Services.Activity
 * @extends Services.Base
 */
Services.Activity = {
    constructor: function() {
        Services.Activity.superclass.constructor.apply(this, arguments);

        this._activities = [];
    },

    _setupEvents: function() {
        this.observable.on({
            "notify:serverManager.slowRequest": this.addActivity.bind(this),
            "notify:serverManager.actionRequestError": this.removeActivity.bind(this),
            "notify:responseParser.responseParsed": this._onResponseParsed.bind(this),
            "request:slowRequestAnimation.show": this.addActivity.bind(this, "request"),
            "notify:responseParser.bonusProgramWidgetValuesParsed": this.removeActivity.bind(this, "widgetspin"),
            "request:slowRequestAnimation.hide": this.removeActivity.bind(this, "request"),
            "notify:realityCheck:completed": this.removeActivity.bind(this),
            "notify:responseParser.freeSpinInitResponseParsed": this.removeActivity.bind(this, "initfreespin"),
            "notify:responseParser.gameConfigurationParsed": this.removeActivity.bind(this, "init"),
            "notify:responseParser.paytableResponseParsed": this.removeActivity.bind(this, "paytable")
        });
    },

    /**
     * Checks if an activity is active.
     *
     * @public
     * @returns {boolean} Whether or not an activity is active.
     */
    isActive: function() {
        return this._activities.length > 0;
    },

    /**
     * Adds an activity to show the indicator for.
     *
     * @param {string} activity The name of the activity to add.
     * @returns {void}
     */
    addActivity: function(activity) {
        this._activities.push(activity);

        if (this._activities.length === 1) {
            this.publish("slow");
        }
    },

    /**
     * Removes the activity.
     *
     * If there are no activities remaining the indicator is marked as removed.
     *
     * @param {*} activity The name of the activity to remove.
     * @returns {void}
     */
    removeActivity: function(activity) {
        var index = this._activities.indexOf(activity);

        if (index === -1) {
            return;
        }

        this._activities.splice(index, 1);

        if (!this.isActive()) {
            this.publish("normal");
        }
    },

    /**
     * Parses the server response in order to remove slow server request activities.
     *
     * @param {Object} response The server response.
     * @returns {void}
     */
    _onResponseParsed: function(response) {
        if (response.clientaction) {
            this.removeActivity(response.clientaction);
        }
    }
};

Services.Activity = Sys.extend(Services.Base, Services.Activity, "Services.Activity");
